import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import TopSuggestion from "./TopSuggestion";

const ClinicAdminDashboard = () => {
  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col className="h-100">
            <TopSuggestion />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ClinicAdminDashboard;
